/**
 * @author PengWen
 * @description zoneCode管理
 * @Date 2022/10/21
 */
 import React from "react";
import { connect } from "dva";
import { templateConfig, reduxTemplateConfig } from "./config";

import { component_tool, framework_tool } from '../../../tool';
let { WizContainer, WizReduxTemplate, modelUtils } = framework_tool;
let { WizBrowserExport } = component_tool;


class ZoneCodeManager extends WizContainer {
  componentName = 'zoneCodeManager';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _handleCMD(nextProps, nextState, key){
    let o = nextProps[key];
    if (o['success']) {
      wizNotice.success(o['msg']);
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '组织名称',
        field: 'orgName',
        width: 35,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '组织编码',
        field: 'orgCode',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: 'zoneCode值',
        field: 'zoneCode',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '数据来源',
        field: 'dataSource',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '状态',
        field: 'state',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      }
    ]
    if (o['success']) {
      let data = o['data']

      const dataSourceMap = { '0' : "第三方推送", '1' : "管理端" };
      const stateMap = { '0': "无效", '1' : "有效" };
      if(data && data instanceof Array && data.length > 0){
        data.forEach(p => {
          p['dataSource'] = dataSourceMap[p['dataSource']]
          p['state'] = stateMap[p['state']]
        })
      }

      WizBrowserExport({
        title: 'zoneCode管理',
        sheetName: 'zoneCode',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: 'zoneCode管理.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _render() {
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig,
      apiDataFormat: {
        delete: this._handleCMD,
        enable: this._handleCMD,
        export: this._handleFile,
      },
    })
    return <WizReduxTemplate {..._reduxTemplateConfig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
  }
};

export default connect(mapStateToProps)(ZoneCodeManager);